// src/components/Footer.js
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full py-4 bg-[black] text-center">
      <h1 className="text-white">All Rights Reserved @Kaizen Global 2024</h1>
      <Link to="/privacy-policy" className=" text-[#E79014] underline mt-2">
        Privacy Policy
      </Link>
      ----
      <Link to="/terms-services" className=" text-[#E79014] underline mt-2">
        Terms And Conditions
      </Link>
    </footer>
  );
}
